import { useState } from "react";


export const useDeleteFinanceAccountStates = () => {
  const [financeAccountId, setFinanceAccountId] = useState("");
  const [institutionType, setInstitutionType] = useState("");

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    financeAccountId,
    institutionType,
    setFinanceAccountId,
    setInstitutionType,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
